(function ($) {

	/*
	 <div class="bigSliderGallery" data-gallery-elements='[
				{"caption":"Artist Residency","buttonText":"View More","buttonLink":"/someLink","imageAlt":"Some Image Alt","imagePath":"/some/image/path","placeholderImagePath":"some/placeholder/path"},
				.
				.
				.
			 ]'></div>
	 */
    Drupal.behaviors.sliderGallery = {
        attach: function (context) {
            Drupal.behaviors.sliderGalleryCreator(context);
        }
    }

    Drupal.behaviors.sliderGalleryCreator = function (context) {

        $(".bigSliderGallery, .smallSliderGallery", context).each(function (index) {
            var mainContent = $(this);
            var isAlreadyModified = $(mainContent).data("saph-done");
            if (isAlreadyModified) {
                return true;
            }

            var maxGalleryElements;

            //Store the anchor point for the gallery to be centered
            var anchorPosition = $(".infoContainer", mainContent).offset();
            var mainOffset = parseInt($(".elementsOuterContainer1", mainContent).css("marginLeft"));
            var mainColOffset = parseInt($(".elementsOuterContainer2", mainContent).css("marginLeft"));
            var galleryElementsArray;
            var lastGalleryElement;
            var lastGalleryElementPosition;
            var galleryElementMargin;
            var currentImageSelected;
            galleryElementsArray = $(".elementsOuterContainer3 .sliderGalleryElement", mainContent).toArray();

            if (galleryElementsArray) {
                maxGalleryElements = galleryElementsArray.length;
                galleryElementsArray = $(".elementsOuterContainer3 .sliderGalleryElement", mainContent).toArray();

                //Add click function to image
                //Call image/element renderer
                currentImageSelected = 0;
                if ($(this).hasClass("smallSliderGallery")) {
                    Drupal.behaviors.sliderGalleryElementCreator($(mainContent), false);
                } else {
                    Drupal.behaviors.sliderGalleryElementCreator($(mainContent), true);
                }

                //Every time the last image is loaded we calculate the width
                $(".elementsOuterContainer3 .lastGalleryElement img", mainContent).on('load', function () {
                    setWidthOfScrollEmptySection();
                });
                if (($(".elementsOuterContainer3 .lastGalleryElement img", mainContent).first()).prop('complete')) {
                    setWidthOfScrollEmptySection();
                }
                Drupal.behaviors.iconCreator($(mainContent));

                //Set default Pages Text
                setPagesText(currentImageSelected);

                setWidthOfScrollEmptySection();
                //$("#extraSpaceSection",mainContent).width(anchorPosition.left);

                function selectLeft() {
                    if (currentImageSelected > 0) {
                        currentImageSelected--;
                        var galleryElementSelected = galleryElementsArray[currentImageSelected];
                        var galleryElementPosition = $(galleryElementSelected).offset();
                        $(".elementsScroller", mainContent).animate({ scrollLeft: ($(".elementsScroller", mainContent).scrollLeft() + Math.floor(galleryElementPosition.left) - Math.floor(anchorPosition.left)) }, 300);
                        setPagesText(currentImageSelected);
                    }
                }
                $(".arrowLeft", mainContent).click(function () {
                    selectLeft();
                });

                function selectRight() {
                    if (currentImageSelected < maxGalleryElements - 1) {
                        currentImageSelected++;
                        var galleryElementSelected = galleryElementsArray[currentImageSelected];
                        var galleryElementPosition = $(galleryElementSelected).offset();
                        $(".elementsScroller", mainContent).animate({ scrollLeft: ($(".elementsScroller", mainContent).scrollLeft() + Math.floor(galleryElementPosition.left) - Math.floor(anchorPosition.left)) }, 300);
                        setPagesText(currentImageSelected);
                    }
                }
                $(".arrowRight", mainContent).click(function () {
                    selectRight();
                });

                //if(Drupal.behaviors.globalVariables.currentMediaType == "Tablet"){
                $(window).bind("load", function () {
                    //console.log("setting up swipe for gallery element");
                    if (Drupal.behaviors.globalVariables.currentMediaType == "Tablet") {
                        $(mainContent).swipe({
                            //Generic swipe handler for all directions
                            swipeLeft: function (event, direction, distance, duration, fingerCount, fingerData) {
                                //if(Drupal.behaviors.globalVariables.currentMediaType == "Tablet"){
                                selectRight();
                                //}
                            },
                            swipeRight: function (event, direction, distance, duration, fingerCount, fingerData) {
                                //if(Drupal.behaviors.globalVariables.currentMediaType == "Tablet"){
                                selectLeft();
                                //}
                            },
                            threshold: 75,
                            allowPageScroll: "vertical"
                        });
                    }
                });


                //}




                $(".elementsScroller", mainContent).scroll(function () {
                    if (Drupal.behaviors.globalVariables.currentMediaType != "Handheld") {
                        return;
                    }
                    var lastGalleryElement = galleryElementsArray[maxGalleryElements - 1];
                    var lastGalleryElementPosition = $(lastGalleryElement).offset();

                    var galleryElementSelected = galleryElementsArray[currentImageSelected];
                    var galleryElementPosition = $(galleryElementSelected).offset();
                    var tmpGalleryElement;
                    var tmpGalleryElementPosition;
                    if (Math.floor(galleryElementPosition.left) < Math.floor(anchorPosition.left)) {
                        for (ind1 = currentImageSelected + 1; ind1 < maxGalleryElements; ind1++) {
                            tmpGalleryElement = galleryElementsArray[ind1];
                            tmpGalleryElementPosition = $(tmpGalleryElement).offset();
                            if (Math.floor(tmpGalleryElementPosition.left) > Math.floor(anchorPosition.left)) {
                                break;
                            } else {
                                currentImageSelected++;
                            }
                        }
                    } else if (Math.floor(galleryElementPosition.left) > Math.floor(anchorPosition.left) && currentImageSelected > 0) {
                        currentImageSelected--;
                        if (currentImageSelected > 0) {
                            for (ind1 = currentImageSelected; ind1 >= 0; ind1--) {
                                tmpGalleryElement = galleryElementsArray[ind1];
                                tmpGalleryElementPosition = $(tmpGalleryElement).offset();
                                if (Math.floor(tmpGalleryElementPosition.left) > Math.floor(anchorPosition.left)) {
                                    currentImageSelected--;
                                } else {
                                    break;
                                }
                            }
                        }
                    }
                    setPagesText(currentImageSelected);
                });


                function setWidthOfScrollEmptySection() {
                    //if viewport width - anchorpoint.left is bigger than last image width then viewport.width -lastImage.width - anchorPoint.left
                    anchorPosition = $(".infoContainer", mainContent).offset();
                    var windowWidth = $(window).width();
                    var lastGalleryElement = galleryElementsArray[maxGalleryElements - 1];
                    //var lastGalleryElementPosition = $(lastGalleryElement).offset();

                    if ((windowWidth - anchorPosition.left) > $(lastGalleryElement).width()) {
                        $(".extraSpaceSection", mainContent).width(windowWidth - anchorPosition.left - $(lastGalleryElement).width());
                    } else {
                        $(".extraSpaceSection", mainContent).width(0);
                    }

                    $(".elementsScroller", mainContent).removeClass("elementAnimation");
                    var galleryElementSelected = galleryElementsArray[currentImageSelected];
                    var galleryElementPosition = $(galleryElementSelected).offset();
                    $(".elementsScroller", mainContent).scrollLeft(($(".elementsScroller", mainContent).scrollLeft() + Math.floor(galleryElementPosition.left) - Math.floor(anchorPosition.left)));
                    $(".elementsScroller", mainContent).addClass("elementAnimation");
                }


                function setPagesText(currentPage) {
                    var actualPage = currentPage + 1;
                    var actualPageText, maxPageText;
                    if (actualPage < 10) {
                        actualPageText = "0" + actualPage;
                    } else {
                        actualPageText = "" + actualPage;
                    }

                    if (maxGalleryElements < 10) {
                        maxPageText = "0" + maxGalleryElements;
                    } else {
                        maxPageText = "" + maxGalleryElements;
                    }

                    $(".infoPageText", mainContent).text(actualPageText + " / " + maxPageText);
                    $(".arrowRight", mainContent).removeClass("dissappearElement-animated");
                    $(".arrowLeft", mainContent).removeClass("dissappearElement-animated");
                    if (currentPage == maxGalleryElements - 1) {
                        $(".arrowRight", mainContent).addClass("dissappearElement-animated");
                        if (maxGalleryElements == 1) {
                            $(".arrowLeft", mainContent).addClass("dissappearElement-animated");
                        }
                    }
                    else if (currentPage == 0) {
                        $(".arrowLeft", mainContent).addClass("dissappearElement-animated");
                    }
                }

                //And Everytime the user resizes the window
                $(window).resize(function () {
                    setWidthOfScrollEmptySection();
                });
                Drupal.behaviors.fullScreenBehaviorCreator($(mainContent).parent());
            }
            $(mainContent).data("saph-done", true);
        });

    }


    //Elements with classes fullScreenBehavior will react to this  

    //You need to add this section for this to work
    // <div id="fullScreenImageContainer" class="hideElement"><div class="fullScreenInnerDiv elementAnimation"><img class="fullScreenImage" data-placeholder-image-path="../{{ directory }}/assets/images/blank.png" src="../{{ directory }}/assets/images/blank.png"></div></div>

    Drupal.behaviors.fullScreenClickHandler = function (context) {
        var imageElement = context;
        var position = $(imageElement).offset();
        var width = $(imageElement).width();
        var height = $(imageElement).height();
        var realWidth = $(imageElement).data("real-width");
        var realHeight = $(imageElement).data("real-height");
        var placeholderImagePath = $(".fullScreenInnerDiv .fullScreenImage").data("placeholder-image-path");
        var posY = position.top - $(window).scrollTop();
        var posX = position.left - $(window).scrollLeft();

        //data-url="{{ item.url }}" data-text="{{ item.text }}" data-caption="{{ item.caption }}"
        //Get text caption and link 
        var caption = $(imageElement).data("caption");
        var title = $(imageElement).data("title"); //Some images display the title
        var text = $(imageElement).data("text");
        var url = $(imageElement).data("url");

        var videoLink = $(imageElement).data("video-link");

        Drupal.behaviors.functions.consolog("fullScreenClickHandler() caption:" + caption);
        Drupal.behaviors.functions.consolog("fullScreenClickHandler() title:" + title);
        Drupal.behaviors.functions.consolog("fullScreenClickHandler() text:" + text);
        Drupal.behaviors.functions.consolog("fullScreenClickHandler() url:" + url);

        if (videoLink) {
            Drupal.behaviors.functions.consolog("This is a video");
            return true;
        }

        var hasText = false;
        if (caption) {
            hasText = true;
            $("#fullScreenImageContainer .fullScreenImageTextContainer-caption-caption").text(caption);
            $("#fullScreenImageContainer .fullScreenImageTextContainer-caption").removeClass("hideElement");
        } else {
            $("#fullScreenImageContainer .fullScreenImageTextContainer-caption").addClass("hideElement");
        }

        if (title) {
            hasText = true;
            $("#fullScreenImageContainer .fullScreenImageTextContainer-title-text").text(title);
            $("#fullScreenImageContainer .fullScreenImageTextContainer-title").removeClass("hideElement");
        } else {
            $("#fullScreenImageContainer .fullScreenImageTextContainer-title").addClass("hideElement");
        }

        if (text && url) {
            hasText = true;
            $("#fullScreenImageContainer .fullScreenImageTextContainer .linkButton").data("text", text);
            $("#fullScreenImageContainer .fullScreenImageTextContainer .linkButton").data("url", url);
            $("#fullScreenImageContainer .fullScreenImageTextContainer .linkButton a").attr("href", url);
            $("#fullScreenImageContainer .fullScreenImageTextContainer .linkButton .linkTextSaph").text(text);
            $("#fullScreenImageContainer .fullScreenImageTextContainer .linkButton").removeClass("hideElement");
        } else {
            $("#fullScreenImageContainer .fullScreenImageTextContainer .linkButton").addClass("hideElement");
        }

        if (hasText) {
            $("#fullScreenImageContainer .fullScreenImageTextContainer").removeClass("hideElement");
        }
        else {
            $("#fullScreenImageContainer .fullScreenImageTextContainer").addClass("hideElement");
        }

        $("#fullScreenImageContainer").addClass("white-bgr");
        $("#fullScreenImageContainer").removeClass("transparent-bgr");
        $("#fullScreenImageContainer").removeClass("hideElement");

        $('.fullScreenImage').css('background-image', "url(" + $(imageElement).attr('src') + ")");
        $('.fullScreenImage').attr('title', $(imageElement).attr('alt'));

        $('.fullScreenInnerDiv').css('top', 0 + "px");
        $('.fullScreenInnerDiv').css('left', 0 + "px");
        $('.fullScreenInnerDiv').css('width', "100%");
        $('.fullScreenInnerDiv').css('height', "100%");

        $("#fullScreenImageContainer").outerHeight(); //Force reflow
        $("#fullScreenImageContainer .fullScreenImageTextContainer").outerHeight(); //Force reflow


        $(window).resize(updateFullscreenImageContainerHeight);      
        updateFullscreenImageContainerHeight();
        setTimeout(updateFullscreenImageContainerHeight, 100);     
        
        setTimeout(function(){
            
            if($('#fullScreenImageContainer').data('is-fullscreen')){
                updateFullscreenImageContainerHeight();

				if($(window).width() > _breakpointMedium){
					$("#fullScreenImageContainer").click(removeFullScreen);
					$("#fullScreenImageContainer").swipe({
						tap: function (event, target) {
							removeFullScreen();
						}
					});
					$(window).bind("scroll touchmove mousewheel", closeOnScroll);
				}
				else{
					$("#fullScreenImageContainer").find(".fullScreenCloseButton").click(removeFullScreen);
				}
            }

        }, 500);      

        $('#fullScreenImageContainer').data('is-visible', true);
        $('#fullScreenImageContainer').data('is-fullscreen', true);
        var imageHighResPath = $(imageElement).data("image-high-res-path");
        if (!imageHighResPath) {
            //If there is no high res defined we use the normal one
            imageHighResPath = $(imageElement).attr('src');
        }
        $('#fullScreenImageContainer').data('image-high-res-path', imageHighResPath);


        //Load high res image and switch it
        $('<img src="' + imageHighResPath + '" class="">').on('load', function () {
            if ($('#fullScreenImageContainer').data('is-visible') && $('#fullScreenImageContainer').data('image-high-res-path') == $(this).attr("src")) {
                $('#fullScreenImageContainer .fullScreenImage').css("background-image", "url(" + imageHighResPath + ")");
            }
        });

        function updateFullscreenImageContainerHeight(){
            var textSectionHeight = 0;
            if($("#fullScreenImageContainer .fullScreenImageTextContainer").height() > 0){
                textSectionHeight = $("#fullScreenImageContainer .fullScreenImageTextContainer").outerHeight();
            }
            $('.fullScreenImage').css('height', $(window).height() - textSectionHeight + "px");
            $('.fullScreenImage').outerHeight();  //Force reflow
        }

        function closeOnScroll(event) {
            try{
                event.preventDefault();
                event.stopPropagation();
            }
            catch(e){
                console.log(e);
            }

            removeFullScreen();
            return false;
        }

        function removeFullScreen() {

            $('#fullScreenImageContainer').data('is-fullscreen', false);

            position = $(context).offset();
            posY = position.top - $(window).scrollTop();
            posX = position.left - $(window).scrollLeft();

            $('.fullScreenInnerDiv').css('top', posY + "px");
            $('.fullScreenInnerDiv').css('left', posX + "px");
            $('.fullScreenInnerDiv').css('width', width + "px");
            $('.fullScreenInnerDiv').css('height', height + "px");

            $("#fullScreenImageContainer").removeClass("white-bgr");
            $("#fullScreenImageContainer").addClass("transparent-bgr");

            $('.fullScreenImage').css('height', "100%");
            $("#fullScreenImageContainer .fullScreenImageTextContainer").addClass("hideElement");

            var transitionEvent = Drupal.behaviors.whichTransitionEvent();
            $('.fullScreenInnerDiv').one(transitionEvent, function (e) {
                $("#fullScreenImageContainer").addClass("hideElement");
                $(window).unbind("scroll touchmove mousewheel", closeOnScroll);
                $('#fullScreenImageContainer').unbind("touchstart click", removeFullScreen);
                $("#fullScreenImageContainer").find(".fullScreenCloseButton").unbind("click", removeFullScreen);

                //$("#fullScreenImageContainer").removeClass("white-bgr");
                //$("#fullScreenImageContainer").addClass("transparent-bgr");
                //	Set to white image
                $('.fullScreenImage').css("background-image", "url(" + placeholderImagePath + ")");
                $('.fullScreenImage').attr('title', '');
                $('#fullScreenImageContainer').data('image-high-res-path', '');
                $('#fullScreenImageContainer').data('is-visible', false);
            });
        }
    }

})(jQuery);